import { render, staticRenderFns } from "./DisclaimerModal.vue?vue&type=template&id=5c3a1e98&scoped=true"
import script from "./DisclaimerModal.vue?vue&type=script&lang=ts"
export * from "./DisclaimerModal.vue?vue&type=script&lang=ts"
import style0 from "./DisclaimerModal.vue?vue&type=style&index=0&id=5c3a1e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a1e98",
  null
  
)

export default component.exports